/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'https://lexback-production.up.railway.app';

const TYPE_META = {
  mention:          { icon: '🔔', label: 'vous a mentionné', color: '#B8860B' },
  new_message:      { icon: '💬', label: 'a écrit un message', color: '#16a34a' },
  client_reply:     { icon: '📨', label: 'a répondu', color: '#3b82f6' },
  dossier_assigned: { icon: '👤', label: 'a assigné un dossier', color: '#8b5cf6' },
};

function _avatarColor(name) {
  const palette = ['#B8860B', '#8b5cf6', '#3b82f6', '#16a34a', '#dc2626', '#f59e0b', '#0ea5e9', '#a855f7'];
  const hash = (name || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return palette[hash % palette.length];
}
function _initials(name) {
  if (!name) return '?';
  return name.trim().split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);
}
function _relativeDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const diff = (now - d) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 86400 * 7) return `il y a ${Math.floor(diff / 86400)} j`;
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export default function Notifications() {
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all | unread

  const token = () => localStorage.getItem('lexback_token');
  const headers = () => ({ Authorization: `Bearer ${token()}` });

  const load = () => {
    setLoading(true);
    const url = `${API_URL}/api/notifications?unread_only=${filter === 'unread'}`;
    fetch(url, { headers: headers() })
      .then(r => r.ok ? r.json() : [])
      .then(data => setNotifs(Array.isArray(data) ? data : []))
      .catch(() => setNotifs([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const markRead = async (id) => {
    await fetch(`${API_URL}/api/notifications/${id}/read`, { method: 'POST', headers: headers() });
    setNotifs(prev => prev.map(n => n.id === id ? { ...n, read_at: new Date().toISOString() } : n));
  };

  const markAllRead = async () => {
    await fetch(`${API_URL}/api/notifications/read-all`, { method: 'POST', headers: headers() });
    const now = new Date().toISOString();
    setNotifs(prev => prev.map(n => n.read_at ? n : { ...n, read_at: now }));
  };

  const handleClick = (notif) => {
    if (!notif.read_at) markRead(notif.id);
    if (notif.dossier_id) {
      navigate(`/dossiers?open=${notif.dossier_id}`);
    }
  };

  const unreadCount = notifs.filter(n => !n.read_at).length;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <div className="section-title">Notifications</div>
          <div style={{ fontSize: '13px', color: 'var(--color-text-secondary)', marginTop: '2px' }}>
            {unreadCount > 0 ? `${unreadCount} non lue${unreadCount > 1 ? 's' : ''}` : 'Tout est à jour'}
          </div>
        </div>
        {unreadCount > 0 && (
          <button onClick={markAllRead} style={{
            background: 'transparent', border: '0.5px solid var(--color-border-secondary)',
            padding: '6px 14px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer',
            color: 'var(--color-text-secondary)',
          }}>Tout marquer comme lu</button>
        )}
      </div>

      <div style={{ display: 'flex', gap: '4px', padding: '3px', background: 'var(--color-background-secondary)', borderRadius: '8px', border: '0.5px solid var(--color-border-tertiary)', width: 'fit-content', marginBottom: '1.5rem' }}>
        {[
          { val: 'all', label: 'Tout' },
          { val: 'unread', label: `Non lues${unreadCount > 0 ? ` (${unreadCount})` : ''}` },
        ].map(t => (
          <button key={t.val} onClick={() => setFilter(t.val)} style={{
            padding: '5px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', border: 'none',
            background: filter === t.val ? 'var(--color-background-primary)' : 'transparent',
            color: filter === t.val ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
            fontWeight: filter === t.val ? 500 : 400,
            boxShadow: filter === t.val ? '0 1px 2px rgba(0,0,0,0.06)' : 'none',
          }}>{t.label}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--color-text-secondary)' }}>Chargement…</div>
      ) : notifs.length === 0 ? (
        <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--color-text-secondary)' }}>
          Aucune notification {filter === 'unread' ? 'non lue' : ''}.
        </div>
      ) : (
        <div style={{
          background: 'var(--color-background-primary)',
          border: '0.5px solid var(--color-border-secondary)',
          borderRadius: '12px',
          overflow: 'hidden',
        }}>
          {notifs.map((n, idx) => {
            const meta = TYPE_META[n.type] || { icon: '•', label: n.type, color: '#9a8f7a' };
            const unread = !n.read_at;
            return (
              <div
                key={n.id}
                onClick={() => handleClick(n)}
                style={{
                  display: 'flex', gap: '12px',
                  padding: '14px 18px',
                  borderBottom: idx === notifs.length - 1 ? 'none' : '0.5px solid var(--color-border-tertiary)',
                  cursor: 'pointer',
                  background: unread ? 'rgba(184,134,11,0.04)' : 'transparent',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#faf7f1'; }}
                onMouseLeave={e => { e.currentTarget.style.background = unread ? 'rgba(184,134,11,0.04)' : 'transparent'; }}
              >
                {/* Avatar acteur */}
                <div style={{ position: 'relative', flexShrink: 0 }}>
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '50%',
                    background: _avatarColor(n.triggered_by_name),
                    color: 'white', fontSize: '11px', fontWeight: 600,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>{_initials(n.triggered_by_name)}</div>
                  <span style={{
                    position: 'absolute', bottom: '-3px', right: '-3px',
                    width: '16px', height: '16px', borderRadius: '50%',
                    background: '#fff', border: `1.5px solid ${meta.color}`,
                    fontSize: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>{meta.icon}</span>
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '13px', color: '#1a1a1a', lineHeight: 1.4 }}>
                    <strong style={{ fontWeight: 600 }}>{n.triggered_by_name || 'Système'}</strong>
                    <span style={{ color: '#5c5446' }}> {meta.label}</span>
                  </div>
                  {n.payload?.dossier_societe && (
                    <div style={{ fontSize: '11.5px', color: '#9a8f7a', marginTop: '2px' }}>
                      <span style={{ fontFamily: 'JetBrains Mono, monospace', color: '#B8860B' }}>{n.payload.dossier_reference}</span>
                      <span> · </span>
                      <span>{n.payload.dossier_societe}</span>
                    </div>
                  )}
                  {n.payload?.excerpt && (
                    <div style={{
                      fontSize: '12px', color: '#5c5446', marginTop: '5px',
                      padding: '6px 10px', background: '#f5f1ea', borderRadius: '6px',
                      borderLeft: `3px solid ${meta.color}`,
                      fontStyle: 'italic',
                    }}>« {n.payload.excerpt}{n.payload.excerpt.length >= 200 ? '…' : ''} »</div>
                  )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px', flexShrink: 0 }}>
                  <div style={{ fontSize: '10.5px', color: '#9a8f7a', whiteSpace: 'nowrap' }}>{_relativeDate(n.created_at)}</div>
                  {unread && (
                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#B8860B' }} title="Non lue" />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
